import React, { Component } from 'react'
import { connect } from 'react-redux'
import { goBack } from 'react-router-redux'

import { readProject } from '../actions/project'

import ProjectDetails from '../components/ProjectDetails'

class ProjectDetailsPage extends Component {
  componentDidMount () {
    const { readProject, match } = this.props
    readProject(match.params.id)
  }

  render () {
    return (<ProjectDetails {...this.props}/>)
  }
}

const mapStateToProps = (state, ownProps) => ({ project: state.project.current })

const mapDispatchToProps = { readProject, goBack }

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailsPage)


// WEBPACK FOOTER //
// ./src/containers/ProjectDetailsPage.js